// Angular
import { Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { SharedService } from '../../../shared/sharedServices/shared.service';
// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from '../../../core/_base/layout';
// Auth

@Component({
	selector: 'kt-auth',
	templateUrl: './auth.component.html',
	styleUrls: ['./auth.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AuthComponent implements OnInit {
	public registerFormData: any;
	public countriesDialingCodes: any;
	public userCellNumber: any;
	public isMaintenance:boolean;

	constructor(
		private translationService: TranslationService,
		private splashScreenService: SplashScreenService,
		private sharedService:SharedService) {
	}
	ngOnInit(): void {
		// this.checkMaintenance();


	// 		setInterval(()=>{
	// 	this.checkMaintenance();
	// },15000)

		this.translationService.setLanguage(this.translationService.getSelectedLanguage());

		this.splashScreenService.hide();
	}


	public checkMaintenance():void{
		this.sharedService.checkMaintenance().subscribe(
			res=>{
				if(res.statusCode){
					if(res.data == 1){
						this.isMaintenance = false;
					}else{
						this.isMaintenance = true;

					}
				}
			}
		)
	}

}
